import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import styles from "../styles/AdminLayout.module.css";

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className={styles.layout}>
      <Sidebar isCollapsed={isSidebarCollapsed} />
      <div
        className={`${styles.main} ${
          isSidebarCollapsed ? styles.collapsed : ""
        }`}
      >
        <Header
          isSidebarCollapsed={isSidebarCollapsed}
          toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        />
        <div className={styles.content}>{children}</div>
        <Footer />
      </div>
    </div>
  );
};

export default AdminLayout;



// import React, { useState } from "react";
// import Header from "../components/Header";
// import Sidebar from "../components/Sidebar";
// import Footer from "../components/Footer";
// import styles from "../styles/AdminLayout.module.css";

// interface AdminLayoutProps {
//   children: React.ReactNode;
// }

// const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

//   return (
//     <div className={styles.layout}>
//       <Sidebar
//         isCollapsed={isSidebarCollapsed}
//         toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//       />
//       <div
//         className={`${styles.main} ${
//           isSidebarCollapsed ? styles.collapsed : ""
//         }`}
//       >
//         <Header
//           isSidebarCollapsed={isSidebarCollapsed}
//           toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
//         />
//         <div className={styles.content}>{children}</div>
//         <Footer />
//       </div>
//     </div>
//   );
// };

// export default AdminLayout;
